import Vue from 'vue'
import VueRouter from 'vue-router'
import vHome from '../views/vHome.vue'

Vue.use(VueRouter)

/* vHome is the landing view, kept eager. Secondary views are lazy-loaded so
   they ship as separate chunks and stay out of the initial bundle. The mission
   page in particular pulls in the heavy map/signature deps only when visited. */
const routes = [
    {path: '/', component: vHome},
    {path: '/login', component: () => import(/* webpackChunkName: "login" */ '../views/vLogin.vue')},
    {path: '/mission/:id?', component: () => import(/* webpackChunkName: "mission" */ '../views/vMissionPage.vue')},
    {path: '/resident-requests', component: () => import(/* webpackChunkName: "resident-requests" */ '../views/vResidentRequests.vue')},
    {path: '/logout', component: () => import(/* webpackChunkName: "logout" */ '../views/vLogout.vue')},
    {path: '/404', component: () => import(/* webpackChunkName: "404" */ '../views/v404.vue')},
    {path: "*", component: () => import(/* webpackChunkName: "404" */ '../views/v404.vue')}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

/* Until now the only thing standing between an anonymous visitor and a view was
   the axios interceptor, so a screen that happened to make no request rendered
   for anyone. This guards navigation itself.

   It is convenience only — sessionStorage is client-side and trivially edited.
   Every admin endpoint re-checks is_admin server-side. */
router.beforeEach((to, from, next) => {
    const hasToken = !!window.sessionStorage.getItem('token');

    if (to.path === '/login') {
        return next();
    }

    if (!hasToken) {
        return next('/login');
    }

    return next();
})

export default router
